import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFetchErrorHandler } from './useLogger';
export function useResourcePatch(resource, params, options) {
  const dispatch = useDispatch();
  const handleFetchError = useFetchErrorHandler('useResourcePatch');
  const label = resource.computeLabel(resource.options.patchPath, {
    ...params,
    ...options?.headers
  });
  const isPatching = useSelector(state => resource.selectIsPatching(state, label));
  const handlePatch = useCallback(async body => {
    try {
      return dispatch(resource.patch(resource.options.patchPath, body, {
        ...options,
        label,
        params
      }));
    } catch (err) {
      handleFetchError(err, `Unable to patch the ${resource.name}.`);
      throw err;
    }
  }, [label]);
  return {
    handlePatch,
    isPatching
  };
}